import { formatNumber } from '../utils/chartUtils'

// Presentational footer / delta x-axis strip. Pure markup: receives the
// already-computed y-axis width, the grouped header/footer cells, and the
// footer scale-drag handler (which stays in the parent — it reads
// viewWindowSizeRef etc.). The onPointerDown gesture on .footer-viewport is
// the x-axis scale drag; double-tap-reset is wired via the same handler chain
// in the parent.
// viewportRef + data-xe/data-xpad: the parent slides the cells with the
// footprint's sub-candle pan offset (placeEdgeRows), same as the header.
export default function ChartFooter({ yAxisWidth, groupedCells, viewportRef, onPointerDown, onTouchStart, onTouchMove, onTouchEnd, onTouchCancel, showDelta = true, onContextMenu }) {
  return (
    <div className="footprint-footer-row" onContextMenu={onContextMenu}>
      <div className="y-axis-footer-cell" style={{ width: yAxisWidth }}>Δ</div>
      <div className="footer-viewport" ref={viewportRef} data-xe={groupedCells.endIdx} data-xpad={groupedCells.rightPadPx} onPointerDown={onPointerDown}
        onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} onTouchCancel={onTouchCancel}>
        {groupedCells.groups.map((g, i) => (
          <div key={i} className={`candle-footer-cell ${g.delta >= 0 ? 'positive' : 'negative'}`} style={{ width: `${g.widthPx}px` }}>
            {showDelta && g.delta !== 0 ? (g.delta > 0 ? '+' : '') + formatNumber(g.delta) : ''}
          </div>
        ))}
      </div>
    </div>
  )
}
